export * from './menu';
export { MdMenuTrigger } from './menu-trigger';
export { fadeInItems, transformMenu } from './menu-animations';
export { MdMenu } from './menu-directive';
export { MdMenuItem } from './menu-item';

//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@angular/material/menu/index.js
// module id = ./node_modules/@angular/material/menu/index.js
// module chunks = vendor